module.exports = __webpack_public_path__ + "img/1 (12).4d4c1b64.png";